export enum SaveAsTemplateField {
    DESCRIPTION   = 'description',
    NOTES         = 'notes',
    LINKS         = 'links',
    SUBTASKS      = 'subtasks',
    TODO_LISTS    = 'todoLists',
    PRIORITY      = 'priority',
    ESTIMATE      = 'estimate',
    STORY_POINTS  = 'storyPoints',
}

export type OptionItem = {
    id      : SaveAsTemplateField
    title   : string
}

export type OptionGroup = {
    title   : string
    items   : OptionItem[]
}

export const OPTION_GROUPS: OptionGroup[] = [
    {
        title: 'Content',
        items: [
            { id: SaveAsTemplateField.DESCRIPTION, title: 'Description' },
            { id: SaveAsTemplateField.NOTES,       title: 'Notes' },
            { id: SaveAsTemplateField.LINKS,       title: 'Links' },
        ],
    },
    {
        title: 'Items',
        items: [
            { id: SaveAsTemplateField.SUBTASKS,   title: 'Subtasks' },
            { id: SaveAsTemplateField.TODO_LISTS, title: 'Todo lists' },
        ],
    },
    {
        title: 'System fields',
        items: [
            { id: SaveAsTemplateField.PRIORITY,     title: 'Priority' },
            { id: SaveAsTemplateField.ESTIMATE,     title: 'Estimate' },
            { id: SaveAsTemplateField.STORY_POINTS, title: 'Story points' },
        ],
    },
]

export const OPTIONS: OptionItem[] = _.flatMap(OPTION_GROUPS, g => g.items)
